export default {
    createFollowUp(id, caseId, treatmentId, followUpDefinitionData, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/followUp/add`,
            method: 'POST',
            data: followUpDefinitionData
        })
    },
    createFollowUpFromNotification(treatmentId, stepId, concern, signature, axios) {
        return axios({
            url: `treatment/${treatmentId}/step/${stepId}/follow_up/${concern}?signature=${signature}`,
            method: 'POST'
        })
    },
    copyFollowUpFromNotification(copyUrl, axios) {
        return axios({
            url: copyUrl,
            method: 'POST'
        })
    },
    generateSignedUrl(id, caseId, treatmentId, followUpDefinition, concern, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/definition/${followUpDefinition}/${concern}/signedUrl`,
            method: 'POST'
        })
    },
    next(id, caseId, treatmentId, followUpId, concern, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/followUp/${followUpId}/next/${concern}`,
            method: 'GET'
        })
    },
    nextFromNotification(nextUrl, axios) {
        console.log(nextUrl)
        return axios({
            url: nextUrl,
            method: 'GET'
        })
    },
    removeLast(id, caseId, treatmentId, followUpId, concern, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/followUp/${followUpId}/removeLast/${concern}`,
            method: 'GET'
        })
    },
    removeLastFromNotification(nextUrl, axios) {
        return axios({
            url: nextUrl,
            method: 'GET'
        })
    },
    update(id, caseId, treatmentId, followUpId, answerData, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/followUp/${followUpId}/next`,
            method: 'POST',
            data: answerData
        })
    },
    updateFromNotification(nextUrl, answerData, axios) {
        return axios({
            url: nextUrl,
            method: 'POST',
            data: answerData
        })
    },
    restart(id, caseId, treatmentId, followUpId, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/followUp/${followUpId}/restart`,
            method: 'POST'
        })
    },
    view(id, caseId, treatmentId, followUpId, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/followUp/${followUpId}/view`,
            method: 'GET'
        })
    },
    sendNotification(treatmentId, followUpDefinitionId, axios) {
        return axios({
            url: `treatments/${treatmentId}/followUpDefinitions/${followUpDefinitionId}/sendNotification`,
            method: 'GET',
        })
    },
    export(id, caseId, treatmentId, followUpId, axios) {
        return axios({
            url: `patients/${id}/medicalCase/${caseId}/treatment/${treatmentId}/followUp/${followUpId}/export`,
            method: 'GET',
            responseType: 'blob'
        })
    },
    fullExport(axios) {
        return axios({
            url: `patients/exportResults`,
            method: 'GET',
            responseType: 'blob'
        })
    },
    dailyExport(axios) {
        return axios({
            url: `patients/exportDailyResults`,
            method: 'GET',
            responseType: 'blob'
        })
    }

}
